import React, { useState, useEffect } from "react";
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { USER_PROMOCODE } from 'helpers/viewContent';
import { getDetail_ } from 'store/services/commonService';
import { DATE_FORMAT_TIME } from "helpers/common";
import { PRODUCT_IMG } from "utils/constant";

//imported
import * as Path from 'routes/paths';
import * as actions from 'store/actions/index.js';

const Detail = ({ dispatch, match }) => {
    let editkey = match.params.id;
    const [editData, setEditData] = useState({});
    async function getData() {
        try {
            let query = {
                url: "promocode/redeem_code_view",
                id: editkey
            }
            dispatch(actions.persist_store({ loader: true }));
            let res = await dispatch(getDetail_(query))
            setEditData(res?.body)
            dispatch(actions.persist_store({ loader: false }));
        } catch (err) {
            dispatch(actions.persist_store({ loader: false }));
            console.log(err);
        }
    }

    useEffect(() => {
        if (editkey) {
            getData()
        }
    }, []);
    return (
        <>
            <Helmet title={USER_PROMOCODE.CURRENT_MODULE} />
            <div className="page-header">
                <h3 className="page-title">
                    <span className="page-title-icon bg-gradient-primary text-white me-2">
                        <i className="mdi mdi-account-multiple menu-icon"></i>
                    </span>  {USER_PROMOCODE.CURRENT_VIEW}
                </h3>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to={Path.user_promocode}>{USER_PROMOCODE.CURRENT_MODULE}</Link></li>
                        <li className="breadcrumb-item active" aria-current="page">Detail</li>
                    </ol>
                </nav>
            </div>

            <div className="row">
                <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-body">
                            <h4><b> User Info </b></h4>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group row">
                                        <label className="col-sm-6 col-form-label">First Name</label>
                                        <div className="col-sm-6 col-form-label">
                                            {editData?.user?.name ? editData?.user?.name : 'N/A'}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group row">
                                        <label className="col-sm-6 col-form-label">Last Name</label>
                                        <div className="col-sm-6 col-form-label">
                                            {editData?.user?.last_name ? editData?.user?.last_name : 'N/A'}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group row">
                                        <label className="col-sm-6 col-form-label"> User Image</label>
                                        <div className="col-sm-6 col-form-label">
                                            <a href={editData?.user?.image ? `${editData?.user?.image}` : "#"} target="_blank">
                                                <img src={editData?.user?.image ? `${editData?.user?.image}`: PRODUCT_IMG} className="mb-2 rounded img-view" alt="image" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group row">
                                        <label className="col-sm-6 col-form-label"> Promo Redeem Date</label>
                                        <div className="col-sm-6 col-form-label">
                                            {editData?.date ? DATE_FORMAT_TIME(editData?.date) : 'N/A'}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <h4><b> Promocode Info </b></h4>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group row">
                                        <label className="col-sm-6 col-form-label">Title</label>
                                        <div className="col-sm-6 col-form-label">
                                            {editData?.promo_code?.title ? editData?.promo_code?.title : 'N/A'}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group row">
                                        <label className="col-sm-6 col-form-label">Code</label>
                                        <div className="col-sm-6 col-form-label">
                                            {editData?.promo_code?.code ? editData?.promo_code?.code : 'N/A'}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group row">
                                        <label className="col-sm-6 col-form-label">Start Date</label>
                                        <div className="col-sm-6 col-form-label">
                                            {editData?.promo_code?.start_date_time ? DATE_FORMAT_TIME(editData?.promo_code?.start_date_time) : 'N/A'}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group row">
                                        <label className="col-sm-6 col-form-label">End Date</label>
                                        <div className="col-sm-6 col-form-label">
                                            {editData?.promo_code?.end_date_time ? DATE_FORMAT_TIME(editData?.promo_code?.end_date_time) : 'N/A'}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group row">
                                        <label className="col-sm-6 col-form-label">Charges</label>
                                        <div className="col-sm-6 col-form-label">
                                            {editData?.promo_code?.charges ? `$ ${editData?.promo_code?.charges}` : 'N/A'}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group row">
                                        <label className="col-sm-6 col-form-label">Is Expired</label>
                                        <div className="col-sm-6 col-form-label">
                                            <p className={`badge badge-gradient-${editData?.promo_code?.is_expired === '1' ? 'success' : 'danger'}`}>{editData?.promo_code?.is_expired === '1' ? 'Yes' : 'No'}</p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group row">
                                        <label className="col-sm-6 col-form-label">Description:</label>
                                        <div className="col-sm-12 col-form-label">
                                            {editData?.promo_code?.description ? editData?.promo_code?.description : 'N/A'}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}

const mapStateToPros = (state) => {
    return {
    }
};
function mapDispatchToProps(dispatch) {
    return { dispatch };
}

export default connect(
    mapStateToPros,
    mapDispatchToProps
)(Detail);